export function timeUntil(target: Date) {
  const now = Date.now();
  const diff = Math.max(0, target.getTime() - now);
  const day = 1000 * 60 * 60 * 24;
  const hour = 1000 * 60 * 60;
  const min = 1000 * 60;
  return {
    days: Math.floor(diff / day),
    hours: Math.floor((diff % day) / hour),
    minutes: Math.floor((diff % hour) / min),
    seconds: Math.floor((diff % min) / 1000),
    done: diff === 0,
  };
}
